import  * as React from 'react';
import  {ChangeEvent} from 'react';
interface InputRangeProps {
    id: string
    name: string;
    min: string;
    max: string;
    value: number;
    step: string;
    onMouseUp: (e: any) => void;
}
const InputRange:React.FC<InputRangeProps> = ({id, min, name, max, value, step, onMouseUp}) => {
    return (
        <div className={'range-slider'}>
            <input
                id={id}
                type="range"
                name={name}
                min={min}
                max={max}
                defaultValue={value}
                step={step}
                onMouseUp={(e) => onMouseUp(e)}
                onKeyUp={(e) => onMouseUp(e)}
                onTouchEnd={(e) => onMouseUp(e)}
            />
            <span>{value}km</span>
        </div>
    );
};

export default InputRange;
